/**
 * Infer vendor icon name from model name for display fallback.
 */
export function inferVendorIcon(modelName: string): string | undefined {
    const n = modelName.toLowerCase()
    if (n.startsWith('hy-') || n.startsWith('hy3-') || n.includes('hunyuan')) {
        return 'Hunyuan.Color'
    }
    if (n.startsWith('youtu-') || n.startsWith('yt-')) {
        return 'https://qcloudimg.tencent-cloud.cn/raw/ea0412b2922135357fa76acf0547262e.png'
    }
    if (n.startsWith('minimax-')) {
        return 'https://qcloudimg.tencent-cloud.cn/raw/dfc43264eab1adc55631072358ba62b6.png'
    }
    return undefined
}
